import React from 'react';
import { connect } from 'react-redux';
import { EUserGroup, IProject, IUser, ProjectUtils, UserGroupLabels } from '@relab/alstom-ptw-shared';
import { Message } from 'semantic-ui-react';

import { appState } from '../../redux/selectors';
import { RootState } from '../../redux/types';
import { TranslationComponent } from '../TranslationComponent';

interface ProjectWarningsComponentProps {
  user: IUser;
  project: IProject;
}

const PProjectWarningsComponent: React.FC<ProjectWarningsComponentProps> = ({ user, project }) => {
  const userHasPermissions = ProjectUtils.checkUserPermissionsOnProject(project, user, [EUserGroup.PRTCM]);

  const missingRoles: string[] = [];
  [EUserGroup.PTW_ISSUER, EUserGroup.METODISTA, EUserGroup.PQM, EUserGroup.EHS].forEach((role) => {
    if (!project.assignees.find((assignee) => assignee.group === role)) {
      missingRoles.push(UserGroupLabels[EUserGroup[role]]);
    }
  });

  if (userHasPermissions && missingRoles.length) {
    return (
      <Message warning>
        <Message.Header>
          <TranslationComponent stringKey={'Missing assignee!'} />
        </Message.Header>
        <p>
          <TranslationComponent stringKey={'Missing user roles:'} /> {missingRoles.join(', ')}
        </p>
      </Message>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state: RootState) => ({
  user: appState(state).user,
});

export const ProjectWarningsComponent = connect(mapStateToProps)(PProjectWarningsComponent);
